import { Mail, Users, Calendar, Megaphone, Settings } from 'lucide-react';

// Uygulama bölümleri (masaüstünde sol ikon çubuğu, mobilde menü çekmecesinde de kullanılır)
export const getNavItems = (user) => [
  { id: 'mail', label: 'E-posta', icon: Mail, testId: 'nav-mail' },
  { id: 'contacts', label: 'Kişiler', icon: Users, testId: 'nav-contacts' },
  { id: 'calendar', label: 'Takvim', icon: Calendar, testId: 'nav-calendar' },
  // Toplu Mail sadece admin'in açtığı kullanıcılarda görünür
  ...(user?.bulk_mail_enabled
    ? [{ id: 'bulk', label: 'Toplu Mail', icon: Megaphone, testId: 'nav-bulk' }]
    : []),
];

const RailButton = ({ item, active, onClick }) => {
  const Icon = item.icon;
  return (
    <button
      onClick={onClick}
      title={item.label}
      aria-current={active ? 'page' : undefined}
      data-testid={item.testId}
      className={`flex flex-col items-center gap-1 w-14 py-2.5 rounded-xl text-[11px] font-medium transition-colors ${
        active
          ? 'bg-rail-foreground/15 text-rail-foreground'
          : 'text-rail-foreground/70 hover:bg-rail-foreground/10 hover:text-rail-foreground'
      }`}
    >
      <Icon className="h-5 w-5" />
      <span className="leading-none">{item.label}</span>
    </button>
  );
};

export const IconRail = ({ currentPage, onNavigate, user }) => (
  <nav
    className="w-[68px] shrink-0 bg-rail flex flex-col items-center justify-between py-3"
    aria-label="Uygulama bölümleri"
    data-testid="icon-rail"
  >
    <div className="flex flex-col items-center gap-1">
      {getNavItems(user).map((item) => (
        <RailButton
          key={item.id}
          item={item}
          active={currentPage === item.id}
          onClick={() => onNavigate(item.id)}
        />
      ))}
    </div>
    <RailButton
      item={{ id: 'settings', label: 'Ayarlar', icon: Settings, testId: 'nav-settings' }}
      active={currentPage === 'settings'}
      onClick={() => onNavigate('settings')}
    />
  </nav>
);

export default IconRail;
